import { css } from "@emotion/react"
import styled from "@emotion/styled"

const dinamicStyles = ({ theme, lowerText }) => css`
  ${lowerText &&
  `
    ${theme.breakpoints.down("xl")} {
      margin-bottom: 79px; 
    }

    ${theme.breakpoints.between("xl", "2xl")} {
      margin-bottom: 94px;  
    }

    ${theme.breakpoints.up("2xl")} {
      margin-bottom: 137px;  
    }
  `}
`

const ListElevenStack = styled.ul`
  list-style-type: none;
  padding: 0;
  ${dinamicStyles}

  ${({ theme }) => theme.breakpoints.up("xl")} {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }
`

export default ListElevenStack
